import React, {useState} from 'react';
import {inject, observer} from 'mobx-react';
import CourseLearnerUI from '../view/CourseLearnerUI';
import CourseLearnerStore from '../store/CourseLearnerStore';
import {useEffect} from 'react';
import {useOutletContext, useParams, useNavigate} from 'react-router-dom';
import {Course} from '../../../../data/models/Course/Course';

interface Props {
  courseLearnerStore?: CourseLearnerStore;
}

export const ENROLLMENT_LIST_PAGE_SIZE = 10;

const CourseLearnerContainer = inject('courseLearnerStore')(
  observer(({courseLearnerStore}: Props) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [pages, setPages] = useState(0);
    const {organizationId, courseId} = useParams();
    const [learnerData, setLearnerData] = React.useState<any[]>([]);
    const [search, setSearch] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [hasEnrolledLearners, setHasEnrolledLearners] = useState(false);
    const navigate = useNavigate();

    const context = useOutletContext() as [any, any, Course];

    useEffect(() => {
      fetchLeaners();
      fetchEnrolledLearnersCount();
      fetchCourse(context[2]?.courseId || '');
    }, [courseLearnerStore, currentPage, search, context]);

    const fetchCourse = (courseId: string) => {
      if (organizationId && courseId) {
        courseLearnerStore!.getCourse(organizationId, courseId).then(course => {
          context[1](course?.title || '');
        });
      }
    };

    const fetchLeaners = async () => {
      if (organizationId && context[2]) {
        setIsLoading(true);
        try {
          const res = await courseLearnerStore!.getOrganizationLearners(
            organizationId,
            context[2].id || '',
            currentPage - 1,
            ENROLLMENT_LIST_PAGE_SIZE,
            search,
          );
          setLearnerData(res.data || []);
          setPages(res.pagesCount);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    const fetchEnrolledLearnersCount = async () => {
      if (organizationId && context[2]) {
        const pagesCount = await courseLearnerStore!.getEnrolledLearnersCount(
          organizationId,
          context[2].id || '',
        );
        setHasEnrolledLearners(pagesCount > 0);
      } else {
        setHasEnrolledLearners(false);
      }
    };

    const onSave = async (selectedLearners: string[], dueDate?: Date) => {
      if (organizationId && context[2]) {
        const success = await courseLearnerStore!.saveLearners(
          selectedLearners,
          organizationId,
          context[2].id || '',
          dueDate,
        );
        if (success) {
          resetData();
          fetchLeaners();
          fetchEnrolledLearnersCount();
        }
      }
    };

    const resetData = () => {
      setCurrentPage(1);
      setLearnerData([]);
    };

    const onPageChange = (page: number) => {
      setCurrentPage(page);
    };

    const onViewEnrolledLearners = () => {
      if (organizationId && context[2] && courseId) {
        navigate(`/manage/${organizationId}/learners`, {
          state: {
            filters: [context[2].id],
            fromPage: 'enrollLearners',
            courseId: courseId,
          },
        });
      }
    };

    return (
      <CourseLearnerUI
        learnerData={learnerData}
        onSave={onSave}
        pages={pages}
        onPageChange={onPageChange}
        search={search}
        onSearchChange={setSearch}
        publishedCourse={context[2]}
        onViewEnrolledLearners={onViewEnrolledLearners}
        hasEnrolledLearners={hasEnrolledLearners}
        isLoading={isLoading}
      />
    );
  }),
);
export default CourseLearnerContainer;
